export const MuiPaper = {
  styleOverrides: {
    elevation1: {
      boxShadow: 'unset',
    },
  },
};
